import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

interface LanguageSwitcherProps {
    readonly showTitle?: boolean
    readonly compact?: boolean
}

export default function LanguageSwitcher({ showTitle = true, compact = false }: Readonly<LanguageSwitcherProps>) {
    const { i18n, t } = useTranslation();

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    return (
        <div className={`language-switcher ${compact ? 'compact' : ''}`}>
            {showTitle && <h3 className="settings-section-title">{t('settings.language')}</h3>}
            <div className="language-options">
                <button
                    className={`language-btn ${i18n.resolvedLanguage === 'es' ? 'active' : ''}`}
                    onClick={() => changeLanguage('es')}
                >
                    🇪🇸 Español
                </button>
                <button
                    className={`language-btn ${i18n.resolvedLanguage === 'en' ? 'active' : ''}`}
                    onClick={() => changeLanguage('en')}
                >
                    🇺🇸 English
                </button>
                <button
                    className={`language-btn ${i18n.resolvedLanguage === 'fr' ? 'active' : ''}`}
                    onClick={() => changeLanguage('fr')}
                >
                    🇫🇷 Français
                </button>
                <button
                    className={`language-btn ${i18n.resolvedLanguage === 'pt' ? 'active' : ''}`}
                    onClick={() => changeLanguage('pt')}
                >
                    🇵🇹 Português
                </button>
            </div>
        </div>
    );
}
